import React, { useState } from "react";
import "./LoginForm.css";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Formik } from "formik";
import { TextField, Typography } from "@mui/material";
import * as Yup from "yup";
import useLogin from "../../../../Hooks/useLogin";
import { loginURL } from "../../../../Hooks/URL";
import config from "../../../../config";

const LoginSchema = Yup.object().shape({
  accountCode: Yup.string().required("Account Code required !!"),
  password: Yup.string()
    .min(8, "Password is too short !!")
    .required("Password required !!"),
});

function LoginForm({ accountCode }) {
  const [newObject, setNewObject] = useState({});
  const [goSave, setGoSave] = useState(false);
  const { saveState, loading } = useLogin({
    url: loginURL,
    goSave,
    setGoSave,
    newObject,
  });

  return (
    <div className="FormWrapper">
      <Typography
        sx={{ fontSize: "25px", fontWeight: "600", textAlign: "center" }}
      >
        Sign In
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: "14px", md: "18px" },
          fontWeight: "300",
          textAlign: "center",
          marginTop: "5px",
        }}
      >
        Welcome, please sign in to continue
      </Typography>
      <Formik
        initialValues={{ accountCode: accountCode ?? "", password: "" }}
        validationSchema={LoginSchema}
        onSubmit={(values) => {
          setNewObject(values);
          setGoSave(true);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form
            className="LoginFormContainer"
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <TextFieldInput
              fullWidth
              name="accountCode"
              type="text"
              placeholder={"Enter your account code"}
              className="LoginInput"
              label="Account Code"
              change={handleChange}
              blur={handleBlur}
              newValue={values.accountCode}
            />
            {errors.accountCode &&
              touched.accountCode &&
              errors.accountCode && (
                <p className="error">
                  {errors.accountCode &&
                    touched.accountCode &&
                    errors.accountCode}
                </p>
              )}

            <TextFieldInput
              fullWidth
              name="password"
              type="password"
              placeholder={"Enter your password"}
              className="LoginInput"
              label="Password"
              change={handleChange}
              blur={handleBlur}
              newValue={values.password}
            />
            {errors.password && touched.password && errors.password && (
              <p className="error">
                {errors.password && touched.password && errors.password}
              </p>
            )}

            <div style={{ display: "flex", justifyContent: "center" }}>
              <PrimaryButton
                classBtn={"center addButton"}
                btnType={"submit"}
                text={"Login"}
                loading={loading}
                style={{
                  textTransform: "capitalize",
                  marginTop: "10px",
                  width: "50%",
                  borderRadius: "5px",
                  color: config.SECONDARY_COLOR,
                  backgroundColor: config.PRIMARY_COLOR,
                  maxHeight: "40px",
                }}
              />
            </div>
          </form>
        )}
      </Formik>

      <Typography
        sx={{
          fontSize: { xs: "14px", md: "16px" },
          fontWeight: "300",
          textAlign: "center",
          marginTop: "15px",
        }}
      >
        Need An Account?{" "}
        <a
          target="_blank"
          href={config.REG_LINK}
          style={{ textDecoration: "underline" }}
        >
          Sign Up
        </a>
      </Typography>
    </div>
  );
}

export default LoginForm;
